export enum EstablishmentRouteName {
  List = 'establishments-list',
}
